export default __webpack_public_path__ + "static/media/salesforce-long.ad0b1842.svg";